(() => {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bVpQW", function(module, exports) {
$parcel$extendImportMap({
    "hzPGn": "handleScroll.ff535430.js",
    "7My2F": "countdown.79af333f.js",
    "kH1zH": "imageResize.ececd9ae.js",
    "1eWoD": "formUtil.beebd407.js"
});

});

parcelRegister("jmrBt", function(module, exports) {
module.exports = $parcel$import("hzPGn").then(()=>parcelRequire('2SQlZ'));

});

parcelRegister("3h4DD", function(module, exports) {
module.exports = $parcel$import("7My2F").then(()=>parcelRequire('j5qgM'));

});

parcelRegister("8ddda", function(module, exports) {
module.exports = $parcel$import("kH1zH").then(()=>parcelRequire('qK8we'));

});

parcelRegister("kXmbJ", function(module, exports) {
module.exports = $parcel$import("1eWoD").then(()=>parcelRequire('1KssV'));

});



parcelRequire("bVpQW");
})();
parcelRequire8661("jmrBt");
parcelRequire8661("3h4DD");
parcelRequire8661("8ddda");
parcelRequire8661("kXmbJ");
const submitFailed = document.getElementById("submit-failed");
const submitFailedButton = submitFailed.querySelector("button");
const submitFailedSpinner = submitFailed.querySelector(".spinner");
const submitSuccess = document.getElementById("submit-success");
const submitokButtonEle = submitSuccess.querySelector("#submitokbutton");
const submitokSpinnerEle = submitSuccess.querySelector(".spinner");
let finalPayload = null;
let mainFormData = {};
let retryCount = 0;
const REQUIRED_FIELDS_TRANSLATION = {
    NAME: "\u59D3\u540D",
    EMAIL: "\u90F5\u4EF6",
    EMAIL_INVALID: "\u7535\u5B50\u90AE\u4EF6\u932F\u8AA4",
    "lunch-starters": "\u5A5A\u79AE\u5348\u5BB4 \u524D\u83DC",
    "lunch-main": "\u5A5A\u79AE\u5348\u5BB4 \u4E3B\u9910",
    "lunch-baby-chair": "\u5A5A\u79AE\u5348\u5BB4 \u5B30\u5152\u6905\u9700\u6C42",
    "dinner-main": "\u904A\u8239\u665A\u9910 \u4E3B\u9910",
    "dinner-baby-chair": "\u904A\u8239\u665A\u9910 \u5B30\u5152\u6905\u9700\u6C42"
};
const FORM_REQUIREMENTS = {
    profile: [
        "NAME",
        "EMAIL"
    ],
    lunch: [
        "lunch-starters",
        "lunch-main",
        "lunch-baby-chair"
    ],
    dinner: [
        "dinner-main",
        "dinner-baby-chair"
    ]
};
const IS_ATTENDING = {
    lunch: "yes",
    dinner: "yes"
};
function jumpTo(id) {
    const destination = document.getElementById(id);
    destination.scrollIntoView({
        block: "start",
        behavior: "smooth"
    });
}
function cacheFormData(data) {
    try {
        localStorage.setItem("rsvp-form", JSON.stringify(data));
    } catch  {
        console.log("bypassing local cache");
        return null;
    }
}
function attendFunction(id) {
    const formEle = document.getElementById(id);
    const formData = new FormData(formEle);
    const menu = formEle.querySelector(".menu");
    IS_ATTENDING[id] = formData.get("ATTEND");
    if (IS_ATTENDING[id] === "no") menu.classList.add("hide-menu");
    else menu.classList.remove("hide-menu");
}
function validateProfileData() {
    const id = "profile";
    const formEle = document.getElementById(id);
    const formData = new FormData(formEle);
    const name = formData.get("NAME");
    const email = formData.get("EMAIL");
    const missingInput = [];
    if (!name && FORM_REQUIREMENTS[id].includes("NAME")) missingInput.push("NAME");
    if (!email && FORM_REQUIREMENTS[id].includes("EMAIL")) missingInput.push("EMAIL");
    mainFormData = {
        ...mainFormData,
        name
    };
    const emailInputEle = document.getElementById("Email");
    const emailRegexPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailInputEle.validity.valid || !emailRegexPattern.test(email)) missingInput.push("EMAIL_INVALID");
    else mainFormData["email"] = email;
    if (missingInput.length === 0) cacheFormData(mainFormData);
    return missingInput;
}
function validateMenuInputs(id) {
    const formEle = document.getElementById(id);
    const formData = new FormData(formEle);
    const starters = formData.get(`${id}-starters`);
    const main = formData.get(`${id}-main`);
    const babyChair = formData.get(`${id}-baby-chair`);
    const childrenFood = formData.get(`${id}-children-food`);
    const message = DOMPurify.sanitize(formData.get(`${id}-message`));
    const missingInput = [];
    if (!starters && FORM_REQUIREMENTS[id].includes(`${id}-starters`)) missingInput.push(`${id}-starters`);
    if (!main && FORM_REQUIREMENTS[id].includes(`${id}-main`)) missingInput.push(`${id}-main`);
    if (!babyChair && FORM_REQUIREMENTS[id].includes(`${id}-baby-chair`)) missingInput.push(`${id}-baby-chair`);
    mainFormData = {
        ...mainFormData,
        [`${id}-main`]: main,
        [`${id}-baby-chair`]: babyChair,
        [`${id}-children-food`]: childrenFood,
        [`${id}-message`]: message,
        [`${id}-starters`]: starters,
        ["lunch-dessert"]: document.querySelector(".lunch-dessert")?.dataset.lunchDessert ?? "",
        ["dinner-starters"]: document.querySelector(".dinner-starters")?.dataset.dinnerStarters ?? "",
        ["dinner-dessert"]: document.querySelector(".dinner-dessert")?.dataset.dinnerDessert ?? ""
    };
    if (missingInput.length > 0) return {
        isValid: false,
        missingInput
    };
    else return {
        isValid: true
    };
}
function validateFormById(is_attending, id) {
    mainFormData[`${id}-attend`] = is_attending ? "yes" : "no";
    const isMenuDataValid = validateMenuInputs(id);
    if (is_attending && !isMenuDataValid.isValid) return isMenuDataValid.missingInput;
    return [];
}
function sendData(data) {
    if (!data) {
        console.log(`not sending ${data}`);
        return;
    }
    console.log(data);
    function addZero(i) {
        if (i < 10) i = "0" + i;
        return i;
    }
    const today = new Date(), year = today.getFullYear(), month = today.getMonth() + 1, day = today.getDate(), h = addZero(today.getHours()), m = addZero(today.getMinutes()), s = addZero(today.getSeconds()), time = h + ":" + m + ":" + s;
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
    });
    lockBodyScroll();
    document.getElementById("loading").style.display = "block";
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: btoa(new TextEncoder().encode(JSON.stringify({
            date: `${month}-${day}-${year}`,
            time,
            ...data
        })).reduce((s, byte)=>s + String.fromCharCode(byte), ""))
    };
    fetch("https://d2j8t795q4li3r.cloudfront.net/register", options).then((response)=>{
        if (!response.ok) throw new Error(response);
        submitokButtonEle.classList.remove("hidden-submit-button");
        submitokSpinnerEle.style.display = "none";
        submitSuccess.style.display = "flex";
        console.log(response);
        return response.json();
    }).then((response)=>console.log(response)).catch((err)=>{
        submitFailedButton.classList.remove("hidden-submit-button");
        submitFailedSpinner.style.display = "none";
        submitFailed.style.display = "flex";
        console.error(err);
    });
}
function submitForm() {
    const is_attending_lunch = IS_ATTENDING["lunch"] === "yes";
    const is_attending_dinner = IS_ATTENDING["dinner"] === "yes";
    const missingDataAlert = [
        ...validateProfileData(),
        ...validateFormById(is_attending_lunch, "lunch"),
        ...validateFormById(is_attending_dinner, "dinner")
    ];
    if (missingDataAlert.length > 0) {
        document.getElementById("Name").scrollIntoView({
            block: "center",
            behavior: "smooth"
        });
        Object.keys(REQUIRED_FIELDS_TRANSLATION).forEach((requiredField)=>{
            if (requiredField === "EMAIL_INVALID" && missingDataAlert.includes(requiredField)) document.querySelector(`.email-field`)?.classList.add("missing-required-field");
            else document.querySelector(`.${requiredField.toLowerCase()}-field`)?.classList[missingDataAlert.includes(requiredField) ? "add" : "remove"]("missing-required-field");
        });
        alert(`Please provide: ${missingDataAlert.map((char)=>char.replace(/-/g, " ").toLowerCase())} 
      
\u{8ACB}\u{586B}\u{5BEB}: ${missingDataAlert.map((char)=>REQUIRED_FIELDS_TRANSLATION[char])}`);
        return;
    }
    const congratsMessageForm = document.getElementById("congratsMessage");
    const formData = new FormData(congratsMessageForm);
    const congratsMessage = formData.get("congrats-message");
    finalPayload = {
        ...mainFormData,
        "congrats-message": congratsMessage
    };
    sendData(finalPayload);
}
function submitRetry() {
    if (retryCount === 3) finalPayload = null;
    retryCount += 1;
    submitFailedSpinner.style.display = "block";
    submitFailedButton.classList.add("hidden-submit-button");
    if (!finalPayload) {
        submitFailed.innerHTML = "<div><h1>Please refresh your page.</h1><h2>\u8ACB\u5237\u65B0\u9801\u9762</h2><button onclick='window.location.reload()'>Refresh \u5237\u65B0</button></div>";
        return;
    }
    sendData(finalPayload);
}
function submitok() {
    submitokSpinnerEle.style.display = "block";
    submitokButtonEle.classList.add("hidden-submit-button");
    setTimeout(()=>{
        window.location.reload();
    }, 200);
}

//# sourceMappingURL=yunandkeat-web.e5ee69f6.js.map
